import React, { useState, useEffect } from 'react';
import { Input } from 'reactstrap';
import Select from '../../../../common/Select';
import InputRange from 'react-input-range';
import { getFormattedColor } from '../../../../IframeConstructor/iframeConstructorHelpers';
import CustomControl from '../../../../CustomControl/CustomControl';

const NewIFrameSetting = ({
  id,
  type,
  parentPath,
  title,
  placeholder,
  default: dflt,
  list,
  min,
  max,
  available,
  onCheck,
  onUnCheck,
  handleGlobalSettingsChange,
  globalSettings,
  currentLandingSettingsOverrides,
  handleCurrentLandingSettingsOverridesChange,
}) => {
  const [draftValue, setDraftValue] = useState(dflt);

  const overrides =
    currentLandingSettingsOverrides && currentLandingSettingsOverrides[`${parentPath}/${id}`];

  // make modifications on mount
  useEffect(() => {
    if (onCheck && globalSettings[`${parentPath}/${id}`] && globalSettings[`${parentPath}/${id}`] !== '0') {
      handleCurrentLandingSettingsOverridesChange((prev) => ({ ...prev, ...onCheck }));
    }
    if (onUnCheck && !globalSettings[`${parentPath}/${id}`]) {
      handleCurrentLandingSettingsOverridesChange((prev) => ({ ...prev, ...onUnCheck }));
    }
  }, []);

  // update draft value on global settings update
  useEffect(() => {
    setDraftValue(globalSettings[`${parentPath}/${id}`]);
  }, [globalSettings]);

  const handleOverridesChange = (checked) => {
    if (checked && onCheck) {
      return handleCurrentLandingSettingsOverridesChange((prev) => ({ ...prev, ...onCheck }));
    }
    if (!checked && onUnCheck) {
      handleCurrentLandingSettingsOverridesChange((prev) => ({ ...prev, ...onUnCheck }));
    }
  };

  const changeGlobalSetting = (value) => {
    handleGlobalSettingsChange((draft) => ({
      ...draft,
      [`${parentPath}/${id}`]: value,
    }));
  };

  const handleLimitedTextInputChange = (e) => {
    if (e.target.value < min) {
      setDraftValue(min);
      changeGlobalSetting(min);
    } else if (e.target.value > max) {
      setDraftValue(max);
      changeGlobalSetting(max);
    } else {
      changeGlobalSetting(e.target.value);
    }
  };

  const handleColorTextInputChange = (e) => {
    const formattedColor = getFormattedColor(e.target.value, globalSettings[`${parentPath}/${id}`]);
    setDraftValue(formattedColor);
    changeGlobalSetting(formattedColor);
  };

  switch (type) {
    case 'text':
      return (
        <div className="new-ifconstructor-setting">
          <label>{title}</label>
          <Input
            type="text"
            placeholder={placeholder}
            onBlur={(e) => handleLimitedTextInputChange(e)}
            onChange={(e) => setDraftValue(e.target.value)}
            value={draftValue}
            disabled={overrides ? !overrides.available : !available}
          />
        </div>
      );
    case 'select':
      return (
        <div className="new-ifconstructor-setting">
          <label>{title}</label>
          <Select
            options={Object.keys(list).map((key) => ({ value: key, label: list[key] }))}
            onChange={(o) => changeGlobalSetting(o.value)}
            value={globalSettings[`${parentPath}/${id}`]}
            clearable={false}
            isDisabled={overrides ? !overrides.available : !available}
          />
        </div>
      );
    case 'color':
      return (
        <div className="new-ifconstructor-setting">
          <label>{title}</label>
          <div style={{ display: 'flex', height: 41 }}>
            <Input
              style={{
                width: '100%',
                maxWidth: 41,
                marginRight: '-2px',
                height: '100%',
                padding: 0,
                height: 41,
              }}
              type="color"
              value={globalSettings[`${parentPath}/${id}`]}
              onChange={(e) => changeGlobalSetting(e.target.value)}
              disabled={overrides ? !overrides.available : !available}
            />
            <Input
              style={{ width: '100%' }}
              type="text"
              value={draftValue}
              onChange={(e) => setDraftValue(e.target.value)}
              onBlur={handleColorTextInputChange}
              onKeyPress={(e) => e.key === 'Enter' && handleColorTextInputChange(e)}
              disabled={overrides ? !overrides.available : !available}
            />
          </div>
        </div>
      );
    case 'range':
      return (
        <>
          <label>{title}</label>
          <div className="new-ifconstructor-setting new-ifconstructor-setting--full">
            <div className="new-ifconstructor-range">
              <div className="new-ifconstructor-range__range-wrapper">
                <InputRange
                  minValue={min}
                  maxValue={max}
                  value={globalSettings[`${parentPath}/${id}`]}
                  onChange={changeGlobalSetting}
                  disabled={overrides ? !overrides.available : !available}
                />
              </div>
              <Input
                type="text"
                value={draftValue}
                onChange={(e) => setDraftValue(e.target.value)}
                onBlur={handleLimitedTextInputChange}
                onKeyPress={(e) => e.key === 'Enter' && handleLimitedTextInputChange(e)}
                className="new-ifconstructor-range__text"
                disabled={overrides ? !overrides.available : !available}
              />
            </div>
          </div>
        </>
      );
    case 'checkbox':
      return (
        <div className="new-ifconstructor-setting">
          <CustomControl
            className="custom-control-xs mb-4"
            id={`${parentPath}/${id}`}
            label={title}
            value="1"
            checked={globalSettings[`${parentPath}/${id}`] && globalSettings[`${parentPath}/${id}`] === '1' || false}
            onChange={(e) => {
              handleOverridesChange(e.target.checked);
              changeGlobalSetting(e.target.checked ? '1' : '0');
            }}
            disabled={overrides ? !overrides.available : !available}
          />
        </div>
      );
    default:
      return null;
  }
};

export { NewIFrameSetting };
